export var SceneEvent = /* @__PURE__ */ ((SceneEvent2) => {
  SceneEvent2["MAX_FRAME_UPDATED"] = "scene_maxFrameUpdated";
  SceneEvent2["REALTIME_STATUS_UPDATED"] = "scene_realtime_status_updated";
  SceneEvent2["FRAME_UPDATED"] = "scene_frame_updated";
  SceneEvent2["PLAY_STATE_UPDATED"] = "scene_play_state_updated";
  return SceneEvent2;
})(SceneEvent || {});
